import { buildApiUrl, resolveApiBaseWithDefault } from './apiBase';
import { createApiHttpClient } from './httpClient';

export const KANBAN_API_BASE = resolveApiBaseWithDefault(
  import.meta.env.VITE_KANBAN_API_URL,
  '/api/kanban'
);

export const buildKanbanUrl = (path: string) => buildApiUrl(KANBAN_API_BASE, path);

export const kanbanHttp = createApiHttpClient();
